import {
    DEALERREQCASHLIFTING_SUCCESS,
    DEALERREQCASHLIFTING_FAILED,
    RESET_DEALERREQCASHLIFTING,
    LOADING_DEALERREQCASHLIFTING,
    NETWORK_ERROR_DEALERREQCASHLIFTING
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerReqCashLifting = () => {
    return { type: RESET_DEALERREQCASHLIFTING };
};

const dealerReqCashLifting = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERREQCASHLIFTING });
    await dealerServices
        .post("requestCashLifting", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerReqCashLiftingsuccess(res.data));
                    break;
                default:
                    dispatch(dealerReqCashLiftingFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERREQCASHLIFTING,
                payload: err
            });
        });
};
function dealerReqCashLiftingsuccess(data) {
    return {
        type: DEALERREQCASHLIFTING_SUCCESS,
        payload: data
    };
}
function dealerReqCashLiftingFailed(data) {
    return {
        type: DEALERREQCASHLIFTING_FAILED,
        payload: data
    };
}

export { resetDealerReqCashLifting, dealerReqCashLifting };
